/**
 * Returns the id from either other objRef or the given objRefOrIf
 * if is a string or number
 */
const getId = objRefOrId => {
  if (objRefOrId == null) {
    return null;
  }
  const t = typeof objRefOrId;
  if (t === 'object') {
    return objRefOrId.id;
  }
  return t === 'string' || t === 'number' ? objRefOrId : null;
};
export default {
  getId
};